// Display metadata for the typed-edge vocabulary used in a wiki
// page's `## Relations` block. Mirrors `WikiPageRelation::KINDS` on
// the Rails side (`app/models/wiki_page_relation.rb`) — when adding
// or renaming a kind, update both this tuple and the Ruby constant.
//
// Pure module, no Vue dependencies — safe to import from views,
// composables, or test fixtures. Same shape as `categoryLabel.ts`.
//
// The tuple's order is the canonical display order: typed forward
// edges first (in the strength order documented in
// `wiki/CONVENTIONS.md`), then the auto-derived `mentioned-by`
// backlinks last. `WikiPageSerializer#serialize_relations` sorts by
// the same order so the API and the SPA agree without either side
// having to re-derive it.
export const RELATION_KINDS = ['supersedes', 'uses', 'contradicts', 'part-of', 'see-also', 'mentioned-by'] as const

export type WikiPageRelationKind = (typeof RELATION_KINDS)[number]

const LABELS: Record<WikiPageRelationKind, string> = {
  supersedes: 'Supersedes',
  uses: 'Uses',
  contradicts: 'Contradicts',
  'part-of': 'Part of',
  'see-also': 'See also',
  'mentioned-by': 'Mentioned by',
}

// Human-readable label for a relation kind. The kind argument is
// typed against the canonical union so any caller passing an
// unrecognised string fails to compile — TS will refuse the call
// before runtime ever sees a missing entry in the LABELS table.
export function relationKindLabel(kind: WikiPageRelationKind): string {
  return LABELS[kind]
}
